import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from '../Info';
import { CustomMUIButton } from '../../../commons/buttons/CustomMUIButton';
import { ReactComponent as EditPencilIcon } from '../../../../assets/images/EditPencil.svg';
import { ButtonClassNames } from '../../../../models/Common';
import { InfoItem } from '../../../../pages/ServiceManagement';
import { useAppSelector } from '../../../../hooks/redux';
import { ReactComponent as Hide } from '../../../../assets/images/HideContent.svg';
import { ReactComponent as Visible } from '../../../../assets/images/ShowContent.svg';

interface InternetDeviceProps {
  login: string;
  handleEditLogin: (login: string, accountId: number, connectionProtocolId: number, selectedLanguage: string) => void;
  password: string;
  handleEditPassword: (accountId: number, connectionProtocolId: number, selectedLanguage: string) => void;
  mac: string;
  handleEditMac: (
    macAddress: string,
    accountId: number,
    connectionProtocolId: number,
    selectedLanguage: string,
  ) => void;
  ip: string;
  accountId: number;
  connectionProtocolId: number;
  isEditingInternetAvailable: boolean;
  handleShowPassword: () => void;
  isShownPassword: boolean;
}

export const InternetDevice: FC<InternetDeviceProps> = ({
  login,
  handleEditLogin,
  password,
  handleEditPassword,
  mac,
  handleEditMac,
  ip,
  accountId,
  connectionProtocolId,
  isEditingInternetAvailable,
  handleShowPassword,
  isShownPassword,
}) => {
  const { t } = useTranslation();
  const { selectedLanguage } = useAppSelector((state) => state.langReducer);
  const internetDeviceInfos: InfoItem[] = [
    {
      label: t('common.login'),
      value: login,
      button: (
        <CustomMUIButton
          label={<EditPencilIcon />}
          handleClick={() => handleEditLogin(login, accountId, connectionProtocolId, selectedLanguage)}
          className={ButtonClassNames.IconFulfilled}
          tooltipText={`${t('tooltip.change')}`}
          isDisabled={isEditingInternetAvailable}
        />
      ),
    },
    {
      label: t('common.password'),
      value: isShownPassword ? password : '**********',
      button: (
        <CustomMUIButton
          label={<EditPencilIcon />}
          handleClick={() => handleEditPassword(accountId, connectionProtocolId, selectedLanguage)}
          className={ButtonClassNames.IconFulfilled}
          tooltipText={`${t('tooltip.change')}`}
          isDisabled={isEditingInternetAvailable}
        />
      ),
      buttonShowPassword: (
        <CustomMUIButton
          label={isShownPassword ? <Hide /> : <Visible />}
          handleClick={() => handleShowPassword()}
          className={ButtonClassNames.IconFulfilled}
          tooltipText={isShownPassword ? `${t('tooltip.hidePassword')}` : `${t('tooltip.showPassword')}`}
          isDisabled={isEditingInternetAvailable}
        />
      ),
    },
    {
      label: t('serviceManagement.macAddress'),
      value: mac,
      button: (
        <CustomMUIButton
          label={<EditPencilIcon />}
          handleClick={() => handleEditMac(mac, accountId, connectionProtocolId, selectedLanguage)}
          className={ButtonClassNames.IconFulfilled}
          tooltipText={`${t('tooltip.change')}`}
          isDisabled={isEditingInternetAvailable}
        />
      ),
    },
    { label: t('serviceManagement.IPAddress'), value: ip },
  ];

  return <Info infoItems={internetDeviceInfos} title={t('serviceManagement.internetDevice')} />;
};
